import { useState } from 'react'
import { useSelector } from 'react-redux'

import QuickSelectComponent from '../../../../components/stories/organisms/top-navigation/components/quick-select/index.jsx'
import { makeSelectProjectId } from '../../../PlanSelection/selectors.js'

import { makeSelectPlan } from '../../../Plan/selectors.js'
import CustomRecursiveList from './custom-recursive-list.jsx'
import { useIntl } from 'react-intl'
import { useDebounce } from '../../../../utils/customHooks.js'

const PlanSelect = () => {
  const [search, setSearch] = useState('')
  const debouncedSearch = useDebounce(search, 300)

  const { formatMessage } = useIntl()
  const projectId = useSelector(makeSelectProjectId())
  const plan = useSelector(makeSelectPlan())

  return (
    <QuickSelectComponent.Root>
      <QuickSelectComponent.Label
        label={plan?.name ?? formatMessage({ id: 'plans' })}
        disabled={!projectId}
      />
      <QuickSelectComponent.List
        setSearchValue={setSearch}
        searchValue={search}
      >
        <CustomRecursiveList search={debouncedSearch} />
      </QuickSelectComponent.List>
    </QuickSelectComponent.Root>
  )
}

export default PlanSelect
